import { useState, useEffect, memo } from "react";
import AlertModal from "./AlertModal";
import { Bell } from "lucide-react";
import { Product } from "../../types/Product";
import stockService from "../../services/stock/stockService";

interface InventoryButtonProps {
  className?: string;
}

const AlertButton = memo(({ className = "" }: InventoryButtonProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [products, setProducts] = useState<Product[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
    
  useEffect(() => {
    fetchLowStockProducts();
  }, []);
    
  useEffect(() => {
    if (isModalOpen) {
      fetchLowStockProducts();
    }
  }, [isModalOpen]);
  
  const fetchLowStockProducts = async () => {
    setIsLoading(true);
    setError(null);
    
    try {
      const products = await stockService.fetchLowStockProducts();
      setProducts(products);
    } catch (err) {
      setError('Failed to load inventory data. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };
  
  const handleButtonClick = () => {
    setIsModalOpen(true);
  };
  
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
    
  const badgeCount = products.length;
  
  return (
    <>
      <button
        onClick={handleButtonClick}
        className={`relative p-2 rounded-md hover:bg-gray-100 dark:hover:bg-neutral-700 transition-colors ${className}`}
        aria-label="Notifications"
      >
        <Bell className="h-5 w-5 text-gray-600 dark:text-neutral-300" />
        {badgeCount > 0 && (
          <span className="absolute top-0 right-0 h-5 w-5 rounded-full bg-red-500 text-white text-xs flex items-center justify-center">
            {badgeCount}
          </span>
        )}
      </button>
      
      <AlertModal
        isVisible={isModalOpen}
        onClose={handleCloseModal}
        products={products}
        isLoading={isLoading}
        error={error}
      />
    </>
  );
});

export default AlertButton;